import { useQuery } from '@tanstack/react-query';
import { fetchAddOnGroups } from '../services/addonGroups';
import type { AddOnGroupListParams } from '../services/addonGroup.types';

export const addonGroupKeys = {
    all:    ['smr', 'addon-groups'] as const,
    list:   (params: AddOnGroupListParams) => [...addonGroupKeys.all, 'list', params] as const,
    detail: (id: string)                   => [...addonGroupKeys.all, 'detail', id]  as const,
};

export function useAddOnGroupsQuery(params: AddOnGroupListParams = {}) {
    return useQuery({
        queryKey: addonGroupKeys.list(params),
        queryFn:  () => fetchAddOnGroups(params),
    });
}
